export const Add_TO_CUSTOM_INSIGHT_ARRAY = 'add_to_custom_insight_array';
export const REMOVE_CUSTOM_INSIGHT_ARRAY_ITEM = 'remove_custom_insight_array_item';
export const EDIT_CUSTOM_INSIGHT_ARRAY_ITEM = 'edit_custom_insight_array_item';
export const ADD_ENTITY = 'add_entity';
export const REMOVE_ENTITY = 'remove_entity';

export const EDIT_OWNERS_SYNC_CONFIG = 'edit_owner_sync_config';
